import withStore, {
  TPresentable,
  TLoadingAwarePresenter
} from "../../core/presenter/withStore";
import Application from "../../Application";
import { IOrganisation } from "../../organisations/model/Organisation";
import { TSearchCriteriaFilter } from "../../search/model/SearchCriteria";

export interface TPortalHomePresenter extends TLoadingAwarePresenter {
  organisation?: IOrganisation;
}

export interface IPortalHomePresenter
  extends TPortalHomePresenter,
    TPresentable {
  onSearch(query: TSearchCriteriaFilter): any;
}

const defaultState: TPortalHomePresenter = {};

const PortalHomePresenter = withStore<
  IPortalHomePresenter,
  TPortalHomePresenter
>(({ application, store, loader, translate }): IPortalHomePresenter => {
  const _store = store;
  const _application: Application = application;
  const state = _store.getState<
    TPortalHomePresenter & TLoadingAwarePresenter
  >();

  const onSearch = (query: TSearchCriteriaFilter) => {
    let _searchQuery = Object.assign({}, query);
    let queryString = Object.keys(_searchQuery)
      .map((item) => `${item}=${query[item]}`)
      .join("&");
    return _application.navigator.push({
      pathname: "/search",
      search: `?${queryString}`
    });
  };

  return {
    ...state,
    store: _store,
    loader,
    application: _application,
    translate,
    onSearch
  };
}, defaultState);

export default PortalHomePresenter;
